import { DeviceMultiselectComponent } from './device-multiselect.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ClimbCommonModule } from '../common/climb-common.module';
import { ClimbServicesModule } from '../services/climb-services.module';

import { IoTService } from './iot.service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        ClimbCommonModule,
        ClimbServicesModule
    ],
    declarations: [
        DeviceMultiselectComponent
    ],
    exports: [
        DeviceMultiselectComponent
    ],
    providers: [
        IoTService
    ]
})
export class IoTSharedModule { }
